import Nullstack from 'nullstack';
export default function IconDeviceSim({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-device-sim",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M6 3h8.5l4.5 4.5v12.5a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1z"
  }), "   ", Nullstack.element("path", {
    d: "M9 11h3v6"
  }), "   ", Nullstack.element("path", {
    d: "M15 17v.01"
  }), "   ", Nullstack.element("path", {
    d: "M15 14v.01"
  }), "   ", Nullstack.element("path", {
    d: "M15 11v.01"
  }), "   ", Nullstack.element("path", {
    d: "M9 14v.01"
  }), "   ", Nullstack.element("path", {
    d: "M9 17v.01"
  }), " ");
}